import { ENDPOINTS } from 'config/endpoints';
import { useMutation } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Credentials } from 'crono-fe-common/types/credentials';
import { User } from 'crono-fe-common/types/user';
import { CronoResponse } from 'crono-fe-common/types/response';
import { MfaLoginData } from 'context/auth/types';
import { AxiosResponse } from 'axios';

export type LoginResponse = AxiosResponse<
  CronoResponse<User> & { mfaRequiredData?: MfaLoginData }
>;

export default function useLogin() {
  const login = (data: Credentials) => {
    const request: Request = {
      url: ENDPOINTS.auth.login,
      config: {
        method: 'post',
        data,
      },
    };

    return client(request) as Promise<LoginResponse>;
  };

  return useMutation<LoginResponse, CronoError, Credentials>(login, {});
}
